export type EntityStatusTone = 'active' | 'inactive' | 'archived';

export const TONE_TO_CHIP_COLOR: Record<EntityStatusTone, 'success' | 'default' | 'warning'> = {
    active: 'success',
    inactive: 'warning',
    archived: 'default',
};
